import React from 'react';

const AdminTest = () => {
  return (
    <div className="fade-in">
      <div className="admin-content">
        <h1 className="page-title">Test Admin</h1>
        <p className="page-subtitle">Si vous voyez cette page, le routage admin fonctionne !</p>

        <div className="table-container">
          <div className="table-header">
            <h3 className="table-title">État du Système</h3>
          </div>
          <div className="p-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="stat-card">
                <div className="stat-header">
                  <div className="stat-title">Layout</div>
                  <div className="stat-icon primary">
                    ✅
                  </div>
                </div>
                <div className="stat-value">Fonctionnel</div>
              </div>

              <div className="stat-card">
                <div className="stat-header">
                  <div className="stat-title">Routage</div>
                  <div className="stat-icon success">
                    ✅
                  </div>
                </div>
                <div className="stat-value">Actif</div>
              </div>

              <div className="stat-card">
                <div className="stat-header">
                  <div className="stat-title">CSS</div>
                  <div className="stat-icon info">
                    ✅
                  </div>
                </div>
                <div className="stat-value">Chargé</div>
              </div>

              <div className="stat-card">
                <div className="stat-header">
                  <div className="stat-title">React</div>
                  <div className="stat-icon warning">
                    ✅
                  </div>
                </div>
                <div className="stat-value">Opérationnel</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminTest;




